import React from 'react';
import './TicketGuide.css';

const TicketGuide = () => {
    return (
        <div className="ticketguide-container">
            <div className="ticketguide-content">
                <h1 className="ticketguide-title">Tickets bearbeiten</h1>
                <p className="ticketguide-subtitle">
                    Die Tickets werden nicht automatisch geschlossen, wenn der User die Nachricht gelesen hat!
                </p>

                <div className="ticketguide-cards">
                    {/* Tickets Renamen */}
                    <div className="ticketguide-card rename">
                        <div className="ticketguide-card-header">
                            <div className="ticketguide-card-header-icon">
                                <i className="fas fa-pen"></i>
                            </div>
                            <h4>Tickets Renamen</h4>
                        </div>
                        <div className="ticketguide-card-body">
                            <h5 className="ticketguide-heading">Farbstruktur</h5>
                            <div className="ticketguide-color-box">
                                <p>🔵 - Highteam Ticket - Beispiel 🔵Moa Charreset</p>
                                <p>🟡 - Ticket in Bearbeitung</p>
                                <p>🟢 - Ticket Bearbeitung abgeschlossen, warten auf schließen des Ticket von Ticket Ersteller</p>
                                <p>🔵 - Erstattung</p>
                                <p>🟣 - Analysten Anliegen</p>
                                <p>⚫ - Fraktionsverwaltung</p>
                                <p>⚪ - CarDev/KleidungDev</p>
                                <p>🟤 - Mapping</p>
                                <p>🔴 - Abgelehnt</p>
                                <p>🟢 - Erledigt</p>
                                <p>Rename Beispiel : $rename 🟢erledigt - Einfach im Ticket eingeben</p>
                            </div>
                        </div>
                    </div>

                    {/* Support Tickets */}
                    <div className="ticketguide-card support">
                        <div className="ticketguide-card-header">
                            <div className="ticketguide-card-header-icon">
                                <i className="fas fa-headset"></i>
                            </div>
                            <h4>Support Tickets</h4>
                        </div>
                        <div className="ticketguide-card-body">
                            <h5 className="ticketguide-heading">Spieler ohne Beweise:</h5>
                            <p>
                                Wenn ein Spieler einen anderen Spieler wegen "FailRP" reporten möchte, ist es zwingend erforderlich, dass der Ticketersteller einen Clip reinschickt, von der gesamten RP-Situation. Ohne Clip wird der Spieler darauf hingewiesen, dass ohne jegliche Beweislage kein Support gemacht wird.
                            </p>

                            <hr />

                            <h5 className="ticketguide-heading">Spieler mit Beweisen:</h5>
                            <p>
                                Wenn ein Spieler einen anderen Spieler wegen "FailRP" reporten möchte, ist es zwingend erforderlich, dass der Ticketersteller einen Clip reinschickt, von der gesamten RP-Situation.
                            </p>
                            <p>
                                Weiteres Vorgehen: Spieler in den Support rufen/holen, ihm den Tatbestand ansprechen, ggf. Gegenclip anschauen. Oftmals ist die gegenüberliegende Seite ganz anders.
                            </p>

                            <hr />

                            <h5 className="ticketguide-heading">Char Reset</h5>
                            <p>
                                Wenn ein Spieler ein Ticket auf macht, weil er ein Char Reset beantragen möchte, muss dies an einem Highteamler weitergeleitet werden !
                            </p>

                            <hr />

                            <h5 className="ticketguide-heading">Anderes:</h5>
                            <p>
                                Jeder Teamler, der ein Support-Ticket bearbeitet, bringt dieses auch alleine zu Ende. Sollten Fragen oder Probleme später im Verlauf bei der Bearbeitung entstehen, die Ihr nicht wisst, fragt bitte einen anderen Teamler um Hilfe. Wir möchten nicht, dass mehrere Teamler in das Ticket reinschreiben, Ausnahme: "Ich übergebe das Ticket an @TEAMLER XYZ", zuvor fragt ihr einen anderen Teamler, ob er euch helfen kann.
                            </p>
                        </div>
                    </div>

                    {/* Zu Unrecht gebannt Tickets */}
                    <div className="ticketguide-card banned">
                        <div className="ticketguide-card-header">
                            <div className="ticketguide-card-header-icon">
                                <i className="fas fa-ban"></i>
                            </div>
                            <h4>Zu Unrecht gebannt Tickets</h4>
                        </div>
                        <div className="ticketguide-card-body">
                            <p>
                                <strong>Die Anfechtung ist der Vertrauensverwaltung, du bist einer von wenigen Teamlern die Banns bearbeiten dürfen!</strong>
                            </p>
                            <h6 className="ticketguide-heading-small">Zu Unrecht gebannt:</h6>
                            <ul className="ticketguide-list">
                                <li>Der Spieler kann nachweisen, dass sein Bann komplett ungerechtfertigt ist.</li>
                                <li>Fehlerhafte Banns</li>
                                <li>Bannlänge weicht extrem weit von dem Strafkatalog ab oder der Bann ist kein Bann-Grund.</li>
                            </ul>
                            <p>Bei Unsicherheit, bitte bei dem HighTeam melden.</p>
                        </div>
                    </div>

                    {/* Rückerstattungs Tickets */}
                    <div className="ticketguide-card refund">
                        <div className="ticketguide-card-header">
                            <div className="ticketguide-card-header-icon">
                                <i className="fas fa-money-bill-wave"></i>
                            </div>
                            <h4>Rückerstattungs Tickets</h4>
                        </div>
                        <div className="ticketguide-card-body">
                            <p>
                                <strong>Die Rückerstattung ist der Vertrauensverwaltung, du bist einer von wenigen Teamlern die Rückerstattungen machen dürfen!</strong>
                            </p>
                            <p>
                                Rückerstattungen werden NUR dann bearbeitet, wenn der Spieler beweisen kann, dass er/sie seine Sachen durch einen:
                            </p>
                            <ul className="ticketguide-list">
                                <li>ungeplanten Server-Restart,</li>
                                <li>Server-Crash,</li>
                                <li>nachweisbaren PC-Crash (Task-Manager zählt nicht),</li>
                                <li>Anordnung des HighTeams,</li>
                                <li>sonstige Fehler (Jedoch zählt OHNE Clip KEIN Support oder Erstattung)</li>
                            </ul>
                            <p>verloren hat.</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default TicketGuide;
